if (!customElements.get('yns-pdp-preview')) {
  customElements.define('yns-pdp-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-preview-open]');
      this.stage = this.querySelector('[data-preview-stage]');
      this.items = [...this.querySelectorAll('[data-preview-item]')];
      this.strings = JSON.parse(this.querySelector('[data-preview-strings]').textContent);
      this.index = 0;
      this.opener.hidden = false;
      this.opener.addEventListener('click', () => {
        this.returnToBuy = false;
        this.dialog.showModal();
        document.documentElement.classList.add('yns-preview-open');
        this.track('preview_open');
        this.show(0);
        this.querySelector('[data-preview-close]').focus();
      }, options);
      this.querySelector('[data-preview-close]').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('[data-preview-return]').addEventListener('click', () => {
        this.returnToBuy = true;
        this.track('preview_return');
        this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.pause();
        document.documentElement.classList.remove('yns-preview-open');
        const primary = this.closest('product-info')?.querySelector('.product-form__submit');
        const target = this.returnToBuy && primary ? primary : this.opener;
        target.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'center', behavior: 'instant' });
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.querySelector('[data-preview-previous]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-preview-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelector('[data-preview-zoom]').addEventListener('click', () => {
        this.setZoom(!this.stage.classList.contains('is-zoomed'));
      }, options);
    }
    disconnectedCallback() {
      this.pause();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('yns-preview-open');
      this.controller?.abort();
      this.ready = false;
    }
    track(action) { this.dispatchEvent(new CustomEvent('yns:pdp-action', { bubbles: true, detail: { action } })); }
    pause() { this.querySelectorAll('video').forEach(video => video.pause()); }
    setZoom(on) {
      this.stage.classList.toggle('is-zoomed', on);
      this.stage.scrollTop = 0;
      this.stage.scrollLeft = 0;
      const button = this.querySelector('[data-preview-zoom]');
      button.setAttribute('aria-pressed', String(on));
      button.textContent = on ? this.strings.fit : this.strings.zoom;
    }
    show(index) {
      if (index < 0 || index >= this.items.length) return;
      this.pause();
      this.index = index;
      this.setZoom(false);
      this.querySelector('[data-preview-error]').hidden = true;
      this.items.forEach((item, i) => { item.hidden = i !== index; });
      const item = this.items[index];
      const template = item.querySelector('template');
      if (template) {
        item.append(template.content.cloneNode(true));
        template.remove();
        const video = item.querySelector('video');
        if (video) video.addEventListener('play', () => this.track('preview_video_play'), { signal: this.controller.signal });
        item.querySelectorAll('video,img').forEach(media => media.addEventListener('error', () => {
          this.querySelector('[data-preview-error]').hidden = false;
        }, { signal: this.controller.signal }));
      }
      if (item.dataset.previewKind === 'page') this.track('preview_page_view');
      this.querySelector('[data-preview-previous]').disabled = index === 0;
      this.querySelector('[data-preview-next]').disabled = index === this.items.length - 1;
      this.querySelector('[data-preview-previous]').hidden = this.items.length === 1;
      this.querySelector('[data-preview-next]').hidden = this.items.length === 1;
      this.querySelector('[data-preview-count]').hidden = this.items.length === 1;
      this.querySelector('[data-preview-count]').textContent = this.strings.counter.replace('[current]', index + 1).replace('[total]', this.items.length);
      this.querySelector('[data-preview-zoom]').hidden = item.dataset.previewKind !== 'page';
    }
  });
}

(() => {
  const config = document.querySelector('[data-yns-pdp-events]');
  if (!config || config.dataset.ready) return;
  config.dataset.ready = 'true';
  const actions = new Set(['preview_open', 'preview_page_view', 'preview_video_play', 'preview_return', 'bundle_open', 'bundle_added']);
  ['pharm', 'crash', 'mastery', 'pink', 'practice'].forEach(key => {
    actions.add('bundle_select_' + key);
    actions.add('bundle_deselect_' + key);
  });
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  document.addEventListener('yns:pdp-action', event => {
    const action = event.detail?.action;
    if (!actions.has(action)) return;
    const name = 'yns_' + config.dataset.productKey + '_' + action;
    config.dataset.lastEvent = name;
    config.dataset.eventCount = String(Number(config.dataset.eventCount || 0) + 1);
    if (config.dataset.themeRole.toLowerCase() !== 'main' || window.Shopify?.designMode) {
      config.dataset.analyticsStatus = 'preview-only';
      return;
    }
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) {
        config.dataset.analyticsStatus = 'consent-unavailable';
        return;
      }
      if (typeof window.clarity !== 'function') {
        config.dataset.analyticsStatus = 'clarity-unavailable';
        return;
      }
      window.clarity('event', name);
      config.dataset.analyticsStatus = 'sent';
    } catch (_) { config.dataset.analyticsStatus = 'unavailable'; }
  });
})();
